import * as L from 'leaflet'
import 'leaflet.markercluster'
import MapPinGreen from '../../../assets/map-pin-solid-green.svg'
import MapPinOrange from '../../../assets/map-pin-solid-orange.svg'
import MapPinRed from '../../../assets/map-pin-solid-red.svg'
import MapPinYellow from '../../../assets/map-pin-solid-yellow.svg'
import MapPinBlue from '../../../assets/map-pin-solid.svg'
import MapPinWhite from '../../../assets/map-pin-solid-white.svg'
import MapPinBlack from '../../../assets/map-pin-solid-black.svg'
import { default as MapPinSolid, default as markerIcon } from '../../../assets/map-pin-solid.svg'
import { LegendMenuProps } from '@msaf/core-react'

export const defaultIcon = new L.Icon({ iconUrl: markerIcon, iconSize: new L.Point(25, 30) }) as L.Icon<L.IconOptions>

export const selectedIcon = new L.Icon({
  iconUrl: markerIcon,
  iconSize: new L.Point(50, 60),
  iconAnchor: new L.Point(25, 40),
  draggable: false,
}) as L.Icon<L.IconOptions>

export const locationIcon = new L.Icon({
  iconUrl: MapPinBlack,
  iconSize: new L.Point(25, 30),
  draggable: false,
})

export const customIconBaseOptions = {
  className: 'c-marker-divicon',
  iconSize: new L.Point(25, 30),
  draggable: false,
}

export const SHOW_MARKER_LABEL_ZOOM_THRESHOLD = 16

export const CUSTOM_ICON_CONFIG = {
  searchKey: 'depth',
  labelKey: 'councilWellNo',
  extraDetailZoomLevel: 12,
  customIconConditions: [
    {
      maxLimit: 10000,
      minLimit: 101,
      color: MapPinRed,
    },
    {
      maxLimit: 101,
      minLimit: 76,
      color: MapPinOrange,
    },
    {
      maxLimit: 75,
      minLimit: 51,
      color: MapPinYellow,
    },
    {
      maxLimit: 50,
      minLimit: 26,
      color: MapPinGreen,
    },
    {
      maxLimit: 25,
      minLimit: 0,
      color: MapPinSolid,
    },
  ],
}

export const LEGEND_MENU_CONFIG: LegendMenuProps = {
  buttonLabel: 'Map legend',
  gutterSize: 'none',
  menuSections: [
    {
      heading: 'Well depth',
      sectionOptions: [
        {
          name: 'Well depth',
          label: '> 100m',
          id: '>100m',
          isChecked: true,
          onChange: () => {},
          mapFeatureTheme: { image: MapPinRed },
          showCheckableField: false,
        },
        {
          name: 'Well depth',
          label: '76 - 100m',
          id: '76 - 100m',
          isChecked: false,
          onChange: () => {},
          mapFeatureTheme: { image: MapPinOrange },
          showCheckableField: false,
        },
        {
          name: 'Well depth',
          label: '51 - 75m',
          id: '51 - 75m',
          isChecked: false,
          onChange: () => {},
          mapFeatureTheme: { image: MapPinYellow },
          showCheckableField: false,
        },
        {
          name: 'Well depth',
          label: '26-50m',
          id: '26-50m',
          isChecked: false,
          onChange: () => {},
          mapFeatureTheme: { image: MapPinGreen },
          showCheckableField: false,
        },
        {
          name: 'Well depth',
          label: '< 25m',
          id: '< 25m',
          isChecked: false,
          onChange: () => {},
          mapFeatureTheme: { image: MapPinBlue },
          showCheckableField: false,
        },
        {
          name: 'Well depth',
          label: 'Unknown',
          id: 'Unknown',
          isChecked: false,
          onChange: () => {},
          mapFeatureTheme: { image: MapPinWhite },
          showCheckableField: false,
        },
      ],
    },
  ],
  isOpen: false,
}
